import type { RouteRecordRaw } from 'vue-router/auto'

// 👉 Redirects
export const redirects: RouteRecordRaw[] = [
  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/',
    name: 'index',
    redirect: to => {
      const userData = useCookie<Record<string, unknown> | null | undefined>('userData')
      const userRole = userData.value?.role

      if (userRole === 'admin')
        return { name: 'admin-dashboard' }
      if (userRole === 'client')
        return { name: 'portfolio' }

      // Redirect guests to the premium landing page
      return { name: 'landing' }
    },
  },
  {
    path: '/pages/user-profile',
    name: 'pages-user-profile',
    redirect: () => ({ name: 'pages-user-profile-tab', params: { tab: 'profile' } }),
  },
  {
    path: '/pages/account-settings',
    name: 'pages-account-settings',
    redirect: () => ({ name: 'pages-account-settings-tab', params: { tab: 'account' } }),
  },
]

export const routes: RouteRecordRaw[] = [
  {
    path: '/apps/ecommerce/settings/product-addon',
    name: 'apps-ecommerce-settings-product-addon',
    redirect: () => ({ name: 'apps-ecommerce-settings', query: { tab: 'Opzioni extra' } }),
    meta: {
      action: 'read',
      subject: 'ecommerce',
      navActiveLink: 'apps-ecommerce-settings',
    },
  },

  // Admin Notification Logs
  {
    path: '/admin/notification-logs',
    name: 'admin-notification-logs',
    component: () => import('@/pages/admin/notification-logs.vue'),
    meta: {
      action: 'read',
      subject: 'admin',
    },
  },

  // WooCommerce module routes removed (focus on ecommerce)
]
